module.exports = __webpack_public_path__ + "img/hero-bg-shape-4.4ee0b21a.svg";